import { NgModule } from '@angular/core'
import { IonicPageModule } from 'ionic-angular'
import { InfinitePaginator } from './infinite-paginator'

@NgModule({
  declarations: [
    InfinitePaginator,
  ],
  imports: [
    IonicPageModule.forChild(InfinitePaginator),
  ],
  exports: [
    InfinitePaginator
  ]
})
export class InfinitePaginatorModule { }



// WEBPACK FOOTER //
// ./src/libs/infinite-paginator/components/infinite-paginator.module.ts